//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank';
import cmLoadmore from '@/components/cmLoadmore.vue'

export default {
     components: {
        cmBlank,cmLoadmore
    },
    data(){
        return {
            keyword:'',
            blankShow:false,
            loadStatus:false,
            loadmoreText:'正在加载。。。',
            busy:false,
            list:[],
            where:[],
            hasNext:0,
            pageFlag:2,
            lastId:0,
        }
    },
    mounted(){
    },
    methods: {
        copy(val){
            this.$func.copy(val,event);
        },
        search(){
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList(){
            this.$api.getWorkerList({last_id:this.lastId,page_flag:this.pageFlag,keyword:this.keyword}).then((res)=>{
                if(res){
                    if(!this.lastId){
                        this.blankShow = res.data.length > 0 ? false : true;
                    }
                    this.hasNext = res.hasNext;
                    this.lastId = res.lastId;
                    res.data.forEach((item)=>{
                        this.list.push(item);
                    });
                }
            })  
        },
        changStatus(id,status){
            this.$func.confirm('确认操作？','提示',()=>{
                this.$func.startLoading('请求中。。。');
                this.$api.changeCurtainWorkerStatus({id:id,status:status}).then((res)=>{
                    if(res){
                        this.$func.endLoading();
                        this.$func.showToast('操作成功');
                        this.search();
                    }
                })  
            })
        },
        del(id){
            this.$func.confirm('确认删除？','提示',()=>{
                this.$func.startLoading('请求中。。。');
                this.$api.curtainDeleteWorker({id:id}).then((res)=>{
                    if(res){
                        this.$func.endLoading();
                        this.$func.showToast('操作成功');
                        this.search();
                    }
                })  
            })
        },
        info(id){
            this.$router.push({name:'curtainAddWorker',params:{id:id}})
        },
        // rebate(id){
        //     this.$router.push({name:'rebate',params:{uid:0,otherId:id}})
        // },
        loadmore(){
            if(this.lastId > 0 && !this.hasNext){
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。'
                return ;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(()=>{
                if(this.blankShow){
                    this.busy = true;
                    this.loadStatus = false;
                    this.loadmoreText = '没有更多了。。。'
                }else{
                    if(this.hasNext > 0){
                        this.loadStatus = false;
                        this.busy = false;
                    }else{
                        this.busy = true;
                        this.loadStatus = true;
                        this.loadmoreText = '没有更多了。。。'
                    }
                }
            },1500)
        }
    },
}



// WEBPACK FOOTER //
// ./src/pages/curtainWorker.vue